export default __webpack_public_path__ + "static/media/epi4VidM.91d13368.jpg";